import React from 'react';
import styles from './SadIllustration.module.scss';

const SadIllustration = () => (
  <div className={styles.container}>
    <div className={styles.mainIcon}>
      {/* Sad face with broken heart */}
      <div className={styles.face}>
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Face circle */}
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="url(#sadGradient)"
            stroke="#94a3b8"
            strokeWidth="2"
          />

          {/* Sad eyes */}
          <ellipse cx="35" cy="40" rx="3" ry="5" fill="#475569" />
          <ellipse cx="65" cy="40" rx="3" ry="5" fill="#475569" />

          {/* Tears */}
          <ellipse cx="32" cy="50" rx="2" ry="8" fill="#3b82f6" className={styles.tear1} />
          <ellipse cx="68" cy="52" rx="2" ry="6" fill="#3b82f6" className={styles.tear2} />

          {/* Sad mouth */}
          <path
            d="M 35 70 Q 50 60 65 70"
            stroke="#475569"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
          />

          <defs>
            <linearGradient id="sadGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#f1f5f9" />
              <stop offset="100%" stopColor="#e2e8f0" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* Broken heart */}
      <div className={styles.brokenHeart}>
        <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Left heart piece */}
          <path
            d="M20 8C20 3.58 16.42 0 12 0C7.58 0 4 3.58 4 8C4 12 8 16 20 28C20 28 20 16 20 8Z"
            fill="#ef4444"
            className={styles.heartLeft}
          />
          {/* Right heart piece */}
          <path
            d="M20 8C20 3.58 23.58 0 28 0C32.42 0 36 3.58 36 8C36 12 32 16 20 28C20 28 20 16 20 8Z"
            fill="#dc2626"
            className={styles.heartRight}
          />
          {/* Crack line */}
          <line x1="20" y1="0" x2="20" y2="28" stroke="#991b1b" strokeWidth="2" className={styles.crack} />
        </svg>
      </div>

      {/* Floating sad particles */}
      <div className={styles.particle1}>💔</div>
      <div className={styles.particle2}>😢</div>
      <div className={styles.particle3}>💧</div>
    </div>

    {/* Sad clouds */}
    <div className={styles.clouds}>
      <div className={styles.cloud1}>
        <svg width="60" height="30" viewBox="0 0 60 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="15" cy="20" rx="15" ry="10" fill="#cbd5e1" />
          <ellipse cx="30" cy="15" rx="18" ry="12" fill="#94a3b8" />
          <ellipse cx="45" cy="20" rx="12" ry="8" fill="#cbd5e1" />
        </svg>
      </div>
      <div className={styles.cloud2}>
        <svg width="50" height="25" viewBox="0 0 50 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="12" cy="18" rx="12" ry="8" fill="#cbd5e1" />
          <ellipse cx="25" cy="12" rx="15" ry="10" fill="#94a3b8" />
          <ellipse cx="38" cy="18" rx="10" ry="6" fill="#cbd5e1" />
        </svg>
      </div>
    </div>
  </div>
);

export default SadIllustration;
